module.exports = __webpack_public_path__ + "img/logo.7962c54f.png";